import { constants } from "../../constants/constant";
import { IContactRequest } from "../../types/types";
import { toast } from "react-toastify";









export default async function ContactService(Props: IContactRequest) {
  const { API_URL } = constants();
  try {
    const response = await fetch(`${API_URL}/contact-us`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: Props.name,
        email: Props.emailAddress,
        companyName: Props.companyName,
        needs: Props.serviceType,
        project_description: Props.projectDescription
      })
    });

    let statusMessage = "";
    let isSucceeded = false;
    let isLoading = false;

    //* unauthorized 🤷
    if (response.status === 401) {
      statusMessage = "Unauthorized!";

      //* conflict exists
    } else if (response.status === 409) {
      statusMessage = "Oops! Your message has already been sent";
      toast.warning("Oops! Your message has already been sent");
    }

    //* Did not fill form correctly
    else if (response.status === 422) {
      statusMessage = "Oops! Looks like you did not fill the form correctly. Please try again.";
      toast.warning("Please fill out all fields before proceeding.");
    }

    //* Already contacted us
    else if (response.status === 500) {
      statusMessage = "You have already contacted us. We will get back to you soon.";
      toast.warning("You have already contacted us. We will get back to you soon.");
    }

    //* something went wrong
    else if (!response.ok) {
      statusMessage = "Something unexpected happened, please try again!";
      toast.error("Something unexpected happened, please try again!");
    } else if (response.status === 200 || response.status === 201 || response.ok) {
      isSucceeded = true;
    }

    return {
      statusMessage,
      isSucceeded,
      isLoading
    };
  } catch (error) {
    console.log(error);
    return {
      statusMessage: "Something unexpected happened, please try again!",
      isSucceeded: false,
      isLoading: false
    };
  }
}